import { Alert, ComponentDialog } from "@mikros/shared-ui";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog } from "@progress/kendo-react-dialogs";
import { useEffect, useRef, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import S3Service from "../../../service/s3Service";
import { toast } from "react-hot-toast";
import ApiServices from "../../../service/apiService";
import { v4 } from "uuid";
import {
  CreateCourse as CC,
  CourseModuleCards,
  GenerativeAiChapters,
} from "@mikros/library";
import { useNavigate } from "react-router-dom";
import { PdfTempChpts } from "./pdfTempChpts";
import { Loading } from "../../common/loading";
import {
  TextArea,
  TextAreaChangeEvent,
  TextBox,
  TextBoxChangeEvent,
} from "@progress/kendo-react-inputs";
import { Field } from "@progress/kendo-react-form";
import { FormMultiSelectAdd } from "@mikros/shared-ui";
import Spinner from "../../../utils/Loader";
import { Upload } from "@progress/kendo-react-upload";
import Account from "../../../utils/apiConfig";
import ErrorHandler from "../../../utils/errorConfig";
import { Error } from "@progress/kendo-react-labels";
import AuthService from "../../../service/authService";
import { jwtDecode } from "jwt-decode";
import { events } from "aws-amplify/api";

export interface PdfGenerativeAiProps {
  duplicateS3File: (
    sourceKey: string,
    destinationKey: string,
    fileType: string
  ) => void;
  handleUploadGiveUrl: (e: CourseModuleCards) => void;
  handleUpdateStatusRev: (
    status: string,
    course: CourseModuleCards
  ) => Promise<boolean>;
  handleUpdateStatusAll: (
    status: string,
    course?: CourseModuleCards
  ) => Promise<boolean>;
}

export interface PdfType {
  chapterCount: number;
  temporaryId: string;
  courseId: string;
  filePath: string;
  summary: boolean;
}

export interface PdfDataType {
  reportInfo: PdfType;
}

export function PdfGenerativeAi(props: PdfGenerativeAiProps) {
  const intl = useIntl();
  const navigate = useNavigate();
  const spinner = new Spinner();
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();

  const [openUploadDialog, setOpenUploadDialog] = useState<boolean>(false);
  const [filePath, setFilePath] = useState<string>("");
  const [isFileUploaded, setIsFileUploaded] = useState<boolean>(false);
  const [uploadFile, setUploadFile] = useState<any>();
  const [ErrorFile, setErrorFile] = useState<boolean>(false);
  const [chapters, setChapters] = useState<GenerativeAiChapters | undefined>(
    undefined
  );
  const [getChptsFailed, setGetChptFailed] = useState<boolean>(false);
  const [sucUploaded, setSucUploaded] = useState<boolean>(false);
  const [courseName, setCourseName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [successPdfUploadDialog, setSuccessPdfUploadDialog] =
    useState<boolean>(false);
  const [failurePdfUploadDialog, setFailurePdfUploadDialog] =
    useState<boolean>(false);
  const uploadRef = useRef(null);

  //error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  const [noFileUpload, setNoFileUpload] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});

  const [sub, setSub] = useState<any>(null);
  const subRef = useRef<any>(null);

  useEffect(() => {
    async function fetchSub() {
      let a = await AuthService.getInstance().getIdToken();
      console.log("id token course", a);
      const decoded: any = jwtDecode(a);
      const subValue = decoded["sub"];
      setSub(subValue);
      subRef.current = subValue;
      console.log("print tenant id inside use effect of edit course", subValue);
    }
    fetchSub();
  }, []);

  const toggleSuccesPdfUploadDialog = () => {
    console.log("inside pdf upload success");
    setSuccessPdfUploadDialog(!successPdfUploadDialog);
  };

  const toggleFailurePdfUploadDialog = () => {
    setFailurePdfUploadDialog(!failurePdfUploadDialog);
  };

  const handleVideoGeneration = async (e: any): Promise<any> => {
    console.log("inside handle video generation of edit course", e);

    const body = {
      courseName: e.courseName,
      chapterName: e.chapterName,
      courseId: e.courseId,
      chapterId: e.chapterId,
      cardId: e.cardId,
      accntId: accountInstance.accntId,
      createdBy: e.createdBy,
      prompt: e.prompt,
      userId: subRef.current,
      cardType: e.cardType,
    };
    console.log("body in edit course handle video generation", body);

    const accntId = body.accntId;
    const courseId = body.courseId;

    const endpoint = `${accntId}/course/${courseId}/genVideo`;

    const api = ApiServices.getInstance();

    if (accntId) {
      return await api
        .makeRequest(endpoint, "POST", body)
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            if (errorInstance && errorInstance.updateErrorCode) {
              await errorInstance.updateErrorCode(res.errorMessage);
            }
            return false;
          }
          console.log("Video generation response:", res);
          return res;
        })
        .catch(async (err) => {
          setErrorFlag(true);
          if (errorInstance && errorInstance.updateErrorCode) {
            await errorInstance.updateErrorCode("Video generation failed");
          }
          return false;
        });
    } else {
      return false;
    }
  };
  // const handleAudioGeneration = async (e: any): Promise<string | false> => {
  //   console.log("Inside handle audio generation of pdf courses", e);

  //   const body = {
  //     courseId: e.courseId,
  //     chapterId: e.chapterId,
  //     cardId: e.cardId,
  //     accntId: accountInstance.accntId,
  //     createdBy: e.createdBy,
  //     prompt: e.prompt,
  //     cardType: e.cardType,
  //     language: e.language,
  //     languageCode: e.languageCode,
  //     style: e.style,
  //     voiceName: e.voiceName,
  //   };
  //   const accntId = body.accntId;
  //   const courseId = body.courseId;

  //   const endpoint = `${accntId}/course/${courseId}/genAudio`;
  //   const api = ApiServices.getInstance();

  //   if (!accntId) {
  //     return false;
  //   }
  //   try {
  //     const res = await api.makeRequest(endpoint, "POST", body);
  //     if (res && res.errorMessage) {
  //       setErrorFlag(true);
  //       if (errorInstance && errorInstance.updateErrorCode) {
  //         await errorInstance.updateErrorCode(res.errorMessage);
  //       }
  //       console.log("audio error response", res);
  //       return false;
  //     }
  //     console.log("Audio generation API response", res);
  //     const parsedBody = JSON.parse(res.body);
  //     const presignedUrl = parsedBody.presignedUrl;
  //     console.log("Presigned url audio being sent in create", presignedUrl);
  //     return presignedUrl;
  //   } catch (err) {
  //     console.error("Error in handle audio gen", err);
  //     setErrorFlag(true);
  //     if (errorInstance && errorInstance.updateErrorCode) {
  //       await errorInstance.updateErrorCode("Audio gen failed");
  //     }
  //     return false;
  //   }
  // };


  const handleAudioGeneration = async (
    e: any
  ): Promise<{ presignedUrl: string; prompt: string } | false> => {
    console.log("Inside handle audio generation of create course", e);
  
    const body = {
      courseId: e.courseId,
      chapterId: e.chapterId,
      cardId: e.cardId,
      accntId: accountInstance.accntId,
      createdBy: e.createdBy,
      prompt: e.prompt,
      cardType: e.cardType,
      language: e.language,
      languageCode: e.languageCode,
      style: e.style,
      voiceName: e.voiceName,
    };
    const accntId = body.accntId;
    const courseId = body.courseId;
  
    const endpoint = `${accntId}/course/${courseId}/genAudio`;
    const api = ApiServices.getInstance();
  
    if (!accntId) {
      return false;
    }
    try {
      const res = await api.makeRequest(endpoint, "POST", body);
      if (res && res.errorMessage) {
        setErrorFlag(true);
        if (errorInstance && errorInstance.updateErrorCode) {
          await errorInstance.updateErrorCode(res.errorMessage);
        }
        console.log("audio error response", res);
        return false;
      }
      console.log("Audio generation API response", res);
      const parsedBody = JSON.parse(res.body);
  
      const presignedUrl = parsedBody.presignedUrl;
      const prompt = parsedBody.prompt; // extract prompt
  
      console.log("Prompt returned in create", prompt);
      console.log("Presigned url audio being sent in create", presignedUrl);
  
  
      return { presignedUrl, prompt };
    } catch (err) {
      console.error("Error in handle audio gen", err);
      setErrorFlag(true);
      if (errorInstance && errorInstance.updateErrorCode) {
        await errorInstance.updateErrorCode("Audio gen failed");
      }
      return false;
    }
  };

  const handleImageGeneration = async (e: any): Promise<string | false> => {
    console.log("inside handle image generation of create course", e);

    const body = {
      courseId: e.courseId,
      chapterId: e.chapterId,
      cardId: e.cardId,
      accntId: accountInstance.accntId,
      createdBy: e.createdBy,
      prompt: e.prompt,
      cardType: e.cardType,
    };

    const accntId = body.accntId;
    const courseId = body.courseId;
    // const endpoint = `${accntId}/course/${courseId}/genMedia`;
    const endpoint = `${accntId}/course/${courseId}/genImage`;
    const api = ApiServices.getInstance();

    if (!accntId) return false;

    const channelPath = `/default/${body.cardId}`;

    try {
      console.log("Connecting to:", channelPath);
      const channel = await events.connect(channelPath);
      console.log("Connected to channel:", channel);

      const presignedUrl: string = await new Promise((resolve, reject) => {
        channel.subscribe({
          next: (data) => {
            console.log("Received data from channel subscription", data);
            try {
              // ONLY parse if it’s still a JSON string
              const eventData =
                typeof data.event === "string"
                  ? JSON.parse(data.event)
                  : data.event;

              const url = eventData?.presignedUrl;
              // if (!url) throw new Error("presignedUrl missing");

              console.log("Presigned URL:", url);
              resolve(url);
            } catch (err) {
              reject("Failed to extract presignedUrl: " + err);
            }
          },
          error: (err) => {
            console.error("Error in channel subscription", err);
            // setLoading(false);
            // spinner.hideSpinner();
            reject("Channel subscription error");
          },
        });

        console.log(
          "Subscribed to channel. Now sending video generation request..."
        );

        // Fire API after subscription starts listening
        api.makeRequest(endpoint, "POST", body).then((res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            if (errorInstance && errorInstance.updateErrorCode) {
              errorInstance.updateErrorCode(res.errorMessage);
            }
            // spinner.hideSpinner();
            // setLoading(false);
            reject("API returned error");
          }
          console.log("Image generation API response:", res);
        });
      });
      // setLoading(false);
      // spinner.hideSpinner();
      return presignedUrl;
    } catch (err) {
      console.error("Error in handleImageGeneration:", err);
      // spinner.hideSpinner();
      // setLoading(false);
      setErrorFlag(true);
      if (errorInstance && errorInstance.updateErrorCode) {
        await errorInstance.updateErrorCode("Image generation failed");
      }
      return false;
    }

    return false;
  };
  const apiCreateCourse = async () => {
    let api = ApiServices.getInstance();
    let date = new Date();
    let course: CC = {
      accntId: accountInstance.accntId,
      courseName: courseName,
      courseId: v4(),
      createdBy: accountInstance.accntId,
      date: date.toISOString(),
      publishedBy: "",
      publishedDate: date.toISOString(),
      reviewedBy: "",
      reviewedDate: "",
      updatedBy: accountInstance.accntId,
      description: description,
    };

    let newCC = { source: "PDFAI", ...course };

    if (accountInstance.accntId) {
      await api
        .makeRequest(`${accountInstance.accntId}/course`, "POST", newCC)
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          const info: PdfDataType = {
            reportInfo: {
              chapterCount: 2,
              temporaryId: "ID!",
              courseId: course.courseId,
              filePath: filePath,
              summary: false,
            },
          };

          await getPdfAiChapters(info);
        });
    }
  };

  const getPdfAiChapters = async (data: PdfDataType) => {
    console.log("Entered the getPdfAiChapters function", data);
    let api = ApiServices.getInstance();
    toast.custom(<Loading />, { duration: Infinity });
    if (accountInstance.accntId) {
      await api
        .makeRequestWithoutSpinner(
          `${accountInstance.accntId}/course/${data.reportInfo.courseId}/pdfGenAiCourse/pdfTempChapters`,
          "POST",
          data
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          spinner.showSpinner();
        })
        .catch((error) => {
          console.log("Pdf generative ai error", error);
        });
    }

    await pullTempChapters(data);
  };

  const pullTempChapters = async (data: PdfDataType) => {
    let postData = {
      chapterCount: data.reportInfo.chapterCount,
      temproryId: data.reportInfo.temporaryId,
    };
    console.log("Entered pullTempChapters");
    let api = ApiServices.getInstance();

    let flag = true;
    let maxMiliSeconds = 0;
    let chapters: GenerativeAiChapters = {} as GenerativeAiChapters;
    while (flag) {
      if (accountInstance.accntId) {
        await api
          .makeRequestWithoutSpinner(
            `${accountInstance.accntId}/course/${data.reportInfo.courseId}/pdfGenAiCourse/pdfTempChapters/pullPdfChapters`,
            "POST",
            postData
          )
          .then(async (res) => {
            if (res && res.errorMessage) {
              setErrorFlag(true);
              await errorInstance.updateErrorCode(res.errorMessage);
              return;
            }
            console.log(res);
            const dt = typeof res === "string" ? true : false;

            if (dt) {
              if (maxMiliSeconds <= 240000) {
                await sleep(5000);
                maxMiliSeconds = maxMiliSeconds + 5000;
              } else {
                spinner.hideSpinner();
                flag = false;
                setGetChptFailed(true);
              }
            } else {
              toast.remove();
              spinner.hideSpinner();
              chapters = res;
              flag = false;
              setChapters(chapters);
            }
          })
          .catch((err) => {
            toast.remove();
            spinner.hideSpinner();
            console.log(err.message);
          });
      }
    }
    console.log(chapters);
    console.log(JSON.stringify(chapters));
  };

  function sleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // const CreateCourseAndGenChapters = async () => {
  //   if (isFileUploaded) {
  //     let info = await apiCreateCourse();
  //   } else {
  //     setErrorFile(true);
  //   }
  // };

  const CreateCourseAndGenChapters = async () => {
    if (!isFileUploaded) {
      setErrorFile(true);
      return;
    }

    let err: any = {}; // Initialize an empty error object

    if (courseName.trim() === "") {
      console.log("inside course name empty");
      err.noCourse = {
        error: intl.formatMessage({
          id: "courses.createCourse.courseNameValidator",
        }),
      };
    }

    if (description.trim() === "") {
      console.log("inside description empty");
      err.noDescription = {
        error: intl.formatMessage({
          id: "courses.createCourse.courseDescValidator",
        }),
      };
    }

    // If there are errors, update state and stop execution
    if (Object.keys(err).length > 0) {
      setErrors(err);
      return;
    }

    let info = await apiCreateCourse();
  };

  const uploadToS3 = (e: any) => {
    console.log("THE NORMAL EVENT OF FILE UPLOADED", e);

    const date = new Date();
    const timeEpoch = date.getTime();

    const filePathUrl = `${e.target.files[0].name}-${timeEpoch}.pdf`;
    const file = e.target.files[0];

    console.log("THE NORMAL FILE UPLOADED", file);

    let s3 = S3Service.getInstance();
    s3.writeFileInFolder(filePathUrl, file.getRawFile(), "course-pdfs")
      .then(async (res) => {
        // toast.success("Successfully uploaded course pdf");
        toggleSuccesPdfUploadDialog();
        const filePath = "course-pdfs/" + filePathUrl;
        setFilePath(filePath);
        setIsFileUploaded(true);
        setSucUploaded(true);
        toast.remove();
      })
      .catch((e) =>
        // toast.error("Something went wrong!")
        {
          toggleFailurePdfUploadDialog();
        }
      );
  };

  const upldFileToS3 = async (e: any) => {
    console.log("This is the file ==>", e);

    const file = e[0];
    const date = new Date();
    const timeEpoch = date.getTime();

    const filePathUrl = `${file.name}-${timeEpoch}.pdf`;

    let s3 = S3Service.getInstance();
    await s3
      .writeFileInFolder(filePathUrl, file.getRawFile(), "course-pdfs")
      .then(async (res) => {
        // toast.success("Successfully uploaded course pdf");
        toggleSuccesPdfUploadDialog();

        console.log("SUCCESSFUL on UPLOADING FILE IN S3");
        setIsFileUploaded(true);
        const filePath = "course-pdfs/" + filePathUrl;
        setFilePath(filePath);
        toast.remove();
      })
      .catch((e) => {
        toggleFailurePdfUploadDialog();
      });
    // toast.error("Something went wrong!"));
  };

  const checkAndUploadToS3 = () => {
    if (uploadFile !== undefined) {
      toast.custom(<Loading />, { duration: Infinity });
      uploadToS3(uploadFile);
      setOpenUploadDialog(false);
    } else {
      // toast.error("File not chosen!");
      setNoFileUpload(true);
    }
  };

  useEffect(() => {
    console.log(openUploadDialog);
  }, [openUploadDialog]);

  useEffect(() => {
    console.log("inside use effect upload file", uploadFile);
    if (uploadFile && uploadRef.current) {
      console.log("inside the if condition of useEffect");
      const btn = (uploadRef.current as HTMLElement).querySelector(
        ".k-button-text"
      );
      if (btn) {
        btn.textContent = intl.formatMessage({
          id: "courses.pdfGenerativeAi.changeSelectedFile",
        });
      }
    }
  }, [uploadFile]);

  return (
    <div>
      {
        <div className="flex flex-col space-y-3">
          {errorFlag && (
            <Dialog className="errorDialogue">
              <Alert
                description={intl.formatMessage({
                  id: errorInstance.errorCode,
                })}
                buttonText={`${intl.formatMessage({
                  id: "users.buttonText.Ok",
                })}`}
                icon={"errorShape.png"}
                iconMsg={intl.formatMessage({
                  id: "iconMsgError",
                })}
                backgroundColor={"mk-red"}
                onClick={() => {
                  setErrorFlag(false);
                  navigate("/courses");
                }}
              />
            </Dialog>
          )}
          {successPdfUploadDialog && (
            <Dialog className="confirmSuccessDialogue">
              <Alert
                // description = {"Successfully uploaded course pdf"}
                description={`${intl.formatMessage({
                  id: "pdfGenerativeAi.successUploadPDF",
                })}`}
                buttonText={`${intl.formatMessage({
                  id: "users.buttonText.Ok",
                })}`}
                icon={"successShape.png"}
                iconMsg={intl.formatMessage({
                  id: "iconMsgSuccess",
                })}
                backgroundColor={"mk-bright-green"}
                onClick={() => {
                  toggleSuccesPdfUploadDialog();
                }}
              />
            </Dialog>
          )}
          {failurePdfUploadDialog && (
            <Dialog className="errorDialogue">
              <Alert
                // description = {"Successfully uploaded course pdf"}
                description={`${intl.formatMessage({
                  id: "pdfGenerativeAi.failureUploadPDF",
                })}`}
                buttonText={`${intl.formatMessage({
                  id: "users.buttonText.Ok",
                })}`}
                icon={"errorShape.png"}
                iconMsg={intl.formatMessage({
                  id: "iconMsgError",
                })}
                backgroundColor={"mk-red"}
                onClick={() => {
                  toggleFailurePdfUploadDialog();
                }}
              />
            </Dialog>
          )}
          {sucUploaded && (
            // <Dialog className="pdfUpload">
            //   <div className="flex flex-col justify-center space-y-3 items-center">
            //     <div className="flex justify-center items-center font-bold text-sm">
            //       {`${intl.formatMessage({
            //         id: "courses.pdfGenerativeAI.fileUploadSuccess",
            //       })}`}
            //     </div>
            //     <Button
            //       themeColor={"success"}
            //       onClick={() => {
            //         setSucUploaded(false);
            //       }}
            //     >
            //       {`${intl.formatMessage({
            //         id: "users.buttonText.Ok",
            //       })}`}
            //     </Button>
            //   </div>
            // </Dialog>
            <Dialog className="errorDialogue">
              <Alert
                // description = {"Successfully uploaded course pdf"}
                description={`${intl.formatMessage({
                  id: "courses.pdfGenerativeAI.fileUploadSuccess",
                })}`}
                buttonText={`${intl.formatMessage({
                  id: "users.buttonText.Ok",
                })}`}
                icon={"errorShape.png"}
                iconMsg={intl.formatMessage({
                  id: "iconMsgError",
                })}
                backgroundColor={"mk-red"}
                onClick={() => {
                  setSucUploaded(false);
                }}
              />
            </Dialog>
          )}

          {getChptsFailed && (
            // <Dialog className="pdfUpload">
            //   <div className="flex flex-col justify-center space-y-3 items-center">
            //     <div className="flex justify-center items-center font-bold text-sm">
            //       {`${intl.formatMessage({
            //         id: "courses.pdfGenerativeAI.fileUploadFailure",
            //       })}`}
            //     </div>
            //     <Button
            //       themeColor={"error"}
            //       onClick={() => {
            //         setGetChptFailed(false);
            //       }}
            //     >
            //       {`${intl.formatMessage({
            //         id: "users.buttonText.Ok",
            //       })}`}
            //     </Button>
            //   </div>
            // </Dialog>

            <Dialog className="errorDialogue">
              <Alert
                // description = {"Successfully uploaded course pdf"}
                description={`${intl.formatMessage({
                  id: "courses.pdfGenerativeAI.fileUploadFailure",
                })}`}
                buttonText={`${intl.formatMessage({
                  id: "users.buttonText.Ok",
                })}`}
                icon={"errorShape.png"}
                iconMsg={intl.formatMessage({
                  id: "iconMsgError",
                })}
                backgroundColor={"mk-red"}
                onClick={() => {
                  setGetChptFailed(false);
                }}
              />
            </Dialog>
          )}
          {ErrorFile && (
            // <Dialog className="pdfUpload">
            //   <div className="flex flex-col justify-center space-y-3 items-center">
            //     <div className="flex justify-center items-center font-bold text-sm">
            //       {`${intl.formatMessage({
            //         id: "courses.pdfGenerativeAI.fileNotUploaded",
            //       })}`}
            //     </div>
            //     <Button
            //       themeColor={"error"}
            //       onClick={() => {
            //         setErrorFile(false);
            //       }}
            //     >
            //       {`${intl.formatMessage({
            //         id: "users.buttonText.Ok",
            //       })}`}
            //     </Button>
            //   </div>
            // </Dialog>

            <Dialog className="errorDialogue">
              <Alert
                // description = {"Successfully uploaded course pdf"}
                description={`${intl.formatMessage({
                  id: "courses.pdfGenerativeAI.fileNotUploaded",
                })}`}
                buttonText={`${intl.formatMessage({
                  id: "users.buttonText.Ok",
                })}`}
                icon={"errorShape.png"}
                iconMsg={intl.formatMessage({
                  id: "iconMsgError",
                })}
                backgroundColor={"mk-red"}
                onClick={() => {
                  setErrorFile(false);
                }}
              />
            </Dialog>
          )}
          {noFileUpload && (
            <Dialog className="errorDialogue">
              <Alert
                // description = {"Successfully uploaded course pdf"}
                description={`${intl.formatMessage({
                  id: "courses.pdfGenerativeAI.toast.failure",
                })}`}
                buttonText={`${intl.formatMessage({
                  id: "users.buttonText.Ok",
                })}`}
                icon={"errorShape.png"}
                iconMsg={intl.formatMessage({
                  id: "iconMsgError",
                })}
                backgroundColor={"mk-red"}
                onClick={() => {
                  // setErrorFile(false);
                  setNoFileUpload(false);
                }}
              />
            </Dialog>
          )}
          {openUploadDialog && (
            <Dialog className="pdfUpload">
              <ComponentDialog
                component={() => (
                  <div>
                    <div className="w-full flex flex-row justify-between items-baseline">
                      <div className="text-sm font-bold pb-3 flex items-center justify-center">
                        {`${intl.formatMessage({
                          id: "courses.pdfGenerativeAI.uploadCourseFile",
                        })}`}
                      </div>
                      <div
                        className="bg-mk-primary-bright py-0.5 px-1.5 text-white font-bold rounded-full hover:cursor-pointer"
                        onClick={() => {
                          setIsFileUploaded(false);
                          setOpenUploadDialog(false);
                          setNoFileUpload(true);
                          // toast.error(
                          //   `${intl.formatMessage({
                          //     id: "courses.pdfGenerativeAI.toast.failure",
                          //   })}`
                          // );
                        }}
                      >
                        {`${intl.formatMessage({
                          id: "courses.pdfGenerativeAI.cross",
                        })}`}
                      </div>
                    </div>
                    <div className="file-upload-container">
                      <input
                        type="file"
                        onChange={(e) => {
                          setUploadFile(e);
                        }}
                        id="fileInput"
                        accept=".pdf"
                        multiple={false}
                      />
                    </div>
                  </div>
                )}
                buttonText={`${intl.formatMessage({
                  id: "users.buttonText.Ok",
                })}`}
                onClick={() => {
                  checkAndUploadToS3();
                }}
              />
            </Dialog>
          )}

          <div className="w-full">
            <div className="font-bold">
              <FormattedMessage id="courses.onClickCourse.courseName" />
            </div>

            <div>
              <Error>{errors.noCourse?.error}</Error>
            </div>

            <TextBox
              valid={true}
              value={courseName}
              className="w-[30%]"
              // onChange={(e: TextBoxChangeEvent) =>
              //   setCourseName(e.value!!.toString())
              // }

              onChange={(e: TextBoxChangeEvent) => {
                setCourseName(e.value!!.toString());
                setErrors((prev: { noCourse: any }) => ({
                  ...prev,
                  noCourse:
                    e.value !== undefined &&
                    typeof e.value === "string" &&
                    e.value.trim()
                      ? null
                      : prev.noCourse,
                }));
              }}
            />
          </div>
          <div className="w-full">
            <div className="font-bold">
              <FormattedMessage id="courses.onClickCourse.description" />
            </div>
            <div>
              <Error>{errors.noDescription?.error}</Error>
            </div>
            <TextArea
              valid={true}
              rows={2}
              cols={80}
              className="w-[60%]"
              value={description}
              // onChange={(e: TextAreaChangeEvent) => setDescription(e.value)}
              onChange={(e: TextAreaChangeEvent) => {
                setDescription(e.value);
                setErrors((prev: { noDescription: any }) => ({
                  ...prev,
                  noDescription:
                    e.value !== undefined &&
                    typeof e.value === "string" &&
                    e.value.trim()
                      ? null
                      : prev.noDescription,
                }));
              }}
            />
          </div>
          <div>
            <Field
              name={"tags"}
              id={"tags"}
              label={
                <strong>
                  <FormattedMessage id="courses.createCourse.tags" />
                </strong>
              }
              component={FormMultiSelectAdd}
              className="bg-white"
              data={[
                intl.formatMessage({
                  id: "courses.pdfGeneratvieAi.AI",
                }),
                intl.formatMessage({
                  id: "courses.pdfGeneratvieAi.Testing",
                }),
                intl.formatMessage({
                  id: "courses.pdfGeneratvieAi.Deployment",
                }),
                intl.formatMessage({
                  id: "courses.pdfGeneratvieAi.Tech",
                }),
                intl.formatMessage({
                  id: "courses.pdfGeneratvieAi.Android",
                }),
              ]}
            />
          </div>

          <div className="w-full">
            <div className="font-bold">Upload File</div>
            {/* <div ref={uploadRef}>
              <Upload
                batch={false}
                // onAdd={async (event) => await upldFileToS3(event.newState)}
                onAdd={async (event) => {
                  const file = event.newState[0];
                  setUploadFile(file.name);
                  await upldFileToS3([file]); // Your logic to upload to S3
                  // Optionally update UI or local state
                  setIsFileUploaded(true);
                }}
                multiple={false}
                defaultFiles={[]}
                withCredentials={false}
                accept={".pdf"}
                showFileList={true}
                showActionButtons={false}
                // saveUrl={
                //   "https://demos.telerik.com/kendo-ui/service-v4/upload/save"
                // }
                // removeUrl={
                //   "https://demos.telerik.com/kendo-ui/service-v4/upload/remove"
                // }
              />
            </div> */}

            <div ref={uploadRef}>
              <Upload
                batch={false}
                autoUpload={false}
                showFileList={true}
                showActionButtons={false}
                onAdd={async (event) => {
                  const file = event.newState[0];
                  setUploadFile(file.name);
                  await upldFileToS3([file]); // Your logic to upload to S3
                  // Optionally update UI or local state
                  setIsFileUploaded(true);
                }}
                multiple={false}
                defaultFiles={[]}
                withCredentials={false}
                accept=".pdf"
              />
            </div>
          </div>
          {chapters === undefined ? (
            <div className={`w-full flex justify-end items-center`}>
              <Button
                themeColor="primary"
                onClick={() => navigate("/courses")}
                className="mr-12"
              >
                <FormattedMessage id="backButton" />
              </Button>
              <Button
                themeColor="primary"
                onClick={() => {
                  CreateCourseAndGenChapters();
                }}
              >
                <FormattedMessage id="generateChaptersButton" />
              </Button>
            </div>
          ) : (
            <></>
          )}
          <div>
            {chapters !== undefined ? (
              <PdfTempChpts
                duplicateS3File={(
                  sourceKey: string,
                  destinationKey: string,
                  fileType: string
                ) => {
                  return props.duplicateS3File(
                    sourceKey,
                    destinationKey,
                    fileType
                  );
                }}
                handleUploadGiveUrl={(e: CourseModuleCards) => {
                  return props.handleUploadGiveUrl(e);
                }}
                handleUpdateStatusRev={(
                  status: string,
                  course: CourseModuleCards
                ): Promise<boolean> => {
                  return props.handleUpdateStatusRev(status, course);
                }}
                handleUpdateStatusAll={(
                  status: string,
                  course?: CourseModuleCards
                ): Promise<boolean> => {
                  return props.handleUpdateStatusAll(status, course);
                }}
                chapterData={chapters}
                handleVideoGeneration={handleVideoGeneration}
                handleImageGeneration={handleImageGeneration}
                handleAudioGeneration={handleAudioGeneration}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
      }
    </div>
  );
}
